import React from 'react';
import { Car, Home, Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from "../components/Header"



const YouseLandingPage = () => {

    const navigate = useNavigate()

    function enviarAuto (){
        navigate("/auto")
    }

    function enviarConstruction(){
      navigate('/construction')
    }
  return (
    <>
    
    <Header />
    <div className="min-h-screen bg-[#f94b1b] ">  
      
      {/* Hero Section */}
      <div className="container  mx-auto px-4 py-12">
        <h1 className="text-white text-4xl md:text-6xl font-bold mb-8">
          Seguro Auto que cabe no seu bolso e na rotina
        </h1>
        <button onClick={enviarAuto} className="bg-transparent border-2 border-white text-white px-6 py-2 rounded-full hover:bg-white hover:text-purple-600 transition duration-300">
          COTE EM 3 MINUTOS
        </button>
      </div>

      {/* Cards Section */}
      <div className="container mx-auto  px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Card 1 - Seguro Auto */}
          <div className="bg-white rounded-lg p-6 shadow-lg">
            <div className="flex items-center space-x-2 mb-4">
              <Car className="text-cyan-500 h-6 w-6" />
              <h2 className="text-xl font-bold">Seguro Auto</h2>
            </div>
            <p className="text-gray-600 mb-4">
              A gente quer que você curta seu carro. Mas se rolar qualquer problema, é so acionar o seguro e ficar tranquilo.
              
            </p>
            <div className="mb-4">
              <p className="text-sm text-gray-500">A partir de:</p>
              <p className="text-2xl font-bold">
                R$ <span className="text-4xl">99,90</span>
                <span className="text-sm font-normal text-gray-500">/mês</span>
              </p>
            </div>
            <button onClick={enviarAuto} className="bg-[#f94b1b] text-white px-6 py-2 rounded-full hover:bg-orange-500 transition duration-300 w-full">
              COTE GRÁTIS
            </button>
            <p className="text-xs text-gray-500 mt-2">
              *O valor poderá variar de acordo com o perfil, região, veículo e coberturas selecionadas.
            </p>
          </div>

          {/* Card 2 - Seguro Residencial */}
          <div className="bg-white rounded-lg p-6 shadow-lg">
            <div className="flex items-center space-x-2 mb-4">
              <Home className="text-orange-500 h-6 w-6" />
              <h2 className="text-xl font-bold">Seguro Residencial</h2>
            </div>
            <p className="text-gray-600 mb-4">
            Com o seguro residencial, você fica tranquilo para aproveitar sua casa e desfrutar de bons momentos ao lado da família.
              
            </p>
            <div className="mb-4">
              <p className="text-sm text-gray-500">A partir de:</p>
              <p className="text-2xl font-bold">
                R$ <span className="text-4xl">29,90</span>
                <span className="text-sm font-normal text-gray-500">/mês</span>
              </p>
            </div>
            <button onClick={enviarConstruction} className="bg-[#f94b1b] text-white px-6 py-2 rounded-full hover:bg-orange-500 transition duration-300 w-full">
              COTE GRÁTIS
            </button>
            <p className="text-xs text-gray-500 mt-2">
              *Valor poderá variar de acordo com o perfil e região.
            </p>
          </div>

          {/* Card 3 - Seguro Vida */}
          <div className="bg-white rounded-lg p-6 shadow-lg">
            <div className="flex items-center space-x-2 mb-4">
              <Heart className="text-green-500 h-6 w-6" />
              <h2 className="text-xl font-bold">Seguro Vida</h2>
            </div>
            <p className="text-gray-600 mb-4">
              Um Seguro de Vida pra ficar numa boa e garantir o futuro de quem é importante pra você ;)
            </p>
            <p>.</p>
            <div className="mb-4">
              <p className="text-sm text-gray-500">A partir de:</p>
              <p className="text-2xl font-bold">
                R$ <span className="text-4xl">29,90</span>
                <span className="text-sm font-normal text-gray-500">/mês</span>
              </p>
            </div>
            <button onClick={enviarConstruction} className="bg-[#f94b1b] text-white px-6 py-2 rounded-full hover:bg-orange-500 transition duration-300 w-full">
              COTE GRÁTIS
            </button>
            <p className="text-xs text-gray-500 mt-2">
              *Valor poderá variar de acordo com o perfil.
            </p>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default YouseLandingPage;
